import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, MessageSquare } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t, locale } = useLang();
  const isFr = locale === "fr";
  return (
    <footer className="relative mt-24 border-t border-[#1E293B]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <h3 className="font-display text-2xl text-amber-glow tracking-[0.2em]">FACOW360</h3>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">{t("home.tagline")}</p>
            <div className="mt-5 flex flex-wrap gap-2" data-testid="footer-quick-channels">
              <a
                href="https://wa.me/32498737919"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-[11px] font-mono-tech uppercase tracking-[0.15em] px-3 py-1.5 rounded-full border border-[#25D366]/40 bg-[#25D366]/10 text-[#25D366] hover:bg-[#25D366]/20 transition"
                data-testid="footer-whatsapp"
                aria-label="WhatsApp Business"
              >
                <MessageCircle size={12} /> WhatsApp
              </a>
              <a
                href="sms:+32498737919"
                className="inline-flex items-center gap-1.5 text-[11px] font-mono-tech uppercase tracking-[0.15em] px-3 py-1.5 rounded-full border border-[#00F0FF]/40 bg-[#00F0FF]/10 text-[#00F0FF] hover:bg-[#00F0FF]/20 transition"
                data-testid="footer-sms"
                aria-label="SMS"
              >
                <MessageSquare size={12} /> SMS
              </a>
            </div>
            <p className="mt-3 text-[11px] text-slate-500 italic leading-relaxed max-w-xs">
              {isFr
                ? "Tél : +32 498 73 79 19 — Privilégiez WhatsApp ou SMS (je suis peut-être en consultation). Merci."
                : "Tel: +32 498 73 79 19 — Please favour WhatsApp or SMS (I may be in consultation). Thank you."}
            </p>
          </div>
          <div>
            <p className="label-overline mb-4">Navigation</p>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/geobiologie" className="hover:text-[#00F0FF]">{t("nav.geobiologie")}</Link></li>
              <li><Link to="/cuisine-vivante" className="hover:text-[#00F0FF]">{t("nav.cuisine")}</Link></li>
              <li><Link to="/magnetisme" className="hover:text-[#00F0FF]">{t("nav.magnetisme")}</Link></li>
              <li><Link to="/sentinelles-vertes" className="hover:text-[#00F0FF]">{isFr ? "Sentinelles Vertes" : "Green Sentinels"}</Link></li>
              <li><Link to="/tarifs" className="hover:text-[#00F0FF]">{t("nav.tarifs") || (isFr ? "Tarifs" : "Pricing")}</Link></li>
            </ul>
          </div>
          <div>
            <p className="label-overline mb-4">{t("footer.contact_title")}</p>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/contact" className="hover:text-[#00F0FF]">{t("nav.contact")}</Link></li>
              <li><Link to="/devis" className="hover:text-[#00F0FF]">{isFr ? "Demande de devis" : "Quote request"}</Link></li>
              <li><Link to="/bilan" className="hover:text-[#00F0FF]">{isFr ? "Bilan de Vitalité" : "Vitality Assessment"}</Link></li>
              <li><Link to="/mentions-legales" className="hover:text-[#00F0FF]" data-testid="footer-legal-link">{t("nav.legal")}</Link></li>
            </ul>
          </div>
        </div>
        <div className="my-12 divider-rune text-xs">
          <span>ᚠ&nbsp;&nbsp;ᚢ&nbsp;&nbsp;ᚦ&nbsp;&nbsp;ᚨ&nbsp;&nbsp;ᚱ</span>
        </div>
        <p
          className="font-display text-center text-base md:text-lg text-amber-glow leading-relaxed max-w-3xl mx-auto"
          data-testid="footer-quote"
        >
          « {t("home.bottom_phrase")} »
        </p>
        <p
          className="mt-10 text-[11px] text-slate-500 text-center italic leading-relaxed max-w-3xl mx-auto"
          data-testid="footer-deontological-disclaimer"
        >
          {t("footer.deontological_disclaimer")}
        </p>
        <p className="mt-2 text-xs text-slate-600 text-center">{t("footer.legal")}</p>
      </div>
    </footer>
  );
};
